import { useSnackbar } from 'notistack';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
} from '@mui/material';

import { CarBrand } from '@/types';
import { useDeleteCarBrandMutation } from '@/services';

export interface DeleteCarBrandProps extends DialogProps {
  carBrand: CarBrand;
  onClose(): void;
}

const DeleteCarBrand: React.FC<DeleteCarBrandProps> = ({ carBrand, onClose, ...props }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [deleteCarBrand, deleteCarBrandResponse] = useDeleteCarBrandMutation();

  async function handleDeleteCarBrand() {
    try {
      await deleteCarBrand(carBrand).unwrap();

      onClose();
    } catch (error) {
      enqueueSnackbar(error.data, { variant: 'error' });
    }
  }

  return (
    <Dialog fullWidth {...props}>
      <DialogTitle fontWeight="bold">{carBrand?.name}</DialogTitle>

      <DialogContent dividers>
        <DialogContentText>Вы действительно хотите удалить "{carBrand?.name}"?</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          color="secondary"
          variant="outlined"
          size="small"
          disabled={deleteCarBrandResponse.isLoading}
          onClick={onClose}
        >
          Закрыть
        </Button>

        <Button
          variant="contained"
          size="small"
          disabled={deleteCarBrandResponse.isLoading}
          onClick={handleDeleteCarBrand}
        >
          Да
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteCarBrand;
